var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoleBasedAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.5V14.25C15 12.1287 15 11.068 14.341 10.409C13.6819 9.75 12.6213 9.75 10.5 9.75L9 11.25L7.5 9.75C5.37868 9.75 4.31802 9.75 3.65901 10.409C3 11.068 3 12.1287 3 14.25V16.5",
    stroke: "#141B34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 4.875V4.125C11.625 2.67526 10.4497 1.5 9 1.5C7.55025 1.5 6.375 2.67526 6.375 4.125V4.875C6.375 6.32475 7.55025 7.49998 9 7.49998C10.4497 7.49998 11.625 6.32475 11.625 4.875Z",
    stroke: "#141B34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12V14.25M13.125 13.125H10.875",
    stroke: "#141B34",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleBasedAnalysis);
export default __webpack_public_path__ + "static/media/RoleBasedAnalysis.a81a4a010fed3449c141ea7136ace768.svg";
export { ForwardRef as ReactComponent };